import type { HelpFile } from '../../types/help'
import { AccessRequestsTestIds } from '../../../testids/AccessRequestsTestIds'

export const accessRequestsHelp: HelpFile = {
  docPage: '/docs/governance/access-requests',
  texts: {
    [AccessRequestsTestIds.accessRequestsList]: 'Alle Zugriffsanträge im System — direkt oder durch eine bevollmächtigte Person im Namen anderer eingereicht.',
    [AccessRequestsTestIds.btnCreateRequest]: 'Zugangsanfrage-Assistenten öffnen: Begünstigte:n wählen, Zugriffsprofile auswählen und zur Genehmigung einreichen.',
    [AccessRequestsTestIds.colBeneficiary]: 'Identität, die bei Genehmigung den Zugriff erhält.',
    [AccessRequestsTestIds.colRequester]: 'Identität, die den Antrag eingereicht hat — weicht bei Delegation vom Begünstigten ab.',
    [AccessRequestsTestIds.colItems]: 'In diesem Antrag enthaltene Zugriffsprofile und weitere Positionen.',
    [AccessRequestsTestIds.colJustification]: 'Begründung des Antrags — für Genehmiger bei der Entscheidung sichtbar.',
  },
}
